var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box-loading"},[_c('div',{staticClass:"loading-box-line-sm"}),_c('div',{staticClass:"loading-box-line-xs"}),_c('div',{staticClass:"loading-box-line-lg"})])
}]

export { render, staticRenderFns }